import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

/********************************
 ********** CONSTANTES **********
 *******************************/
import { COLOR } from '@/constants/colors'

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';


/**
 * Store del SnackBar para cuando se agrega/modifica/elimina/error
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'Snack_Bar',
  setup(__props) {

const store             = useStore();
// const storeSnackBar = useSnackBarStore()

/**
 * Objeto de la STORE
 */
const getSnack = computed(() => store.state.snackbar)

/**
 * Constantes de los COLORES
 */
const COLORSNACK:any = {
    add : COLOR.green,
    edit : COLOR.warning,
    delete : COLOR.red,
    // error : COLOR.error,
    error : COLOR.green,
}

/**
 * Captura el color del SnackBar dependiendo del tipo
 */
function getColor(type:string){
    let colorSnack = COLORSNACK[type]
    return colorSnack
}

       

return (_ctx: any,_cache: any) => {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: getSnack.value.valor,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((getSnack.value.valor) = $event)),
    timeout: 5000,
    color: getColor(getSnack.value.type)
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(getSnack.value.msg), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "color"]))
}
}

})